import _ from 'lodash';

import {
  HighlightableString,
  isHighlightableString,
} from '@/app/log-viewer/highlighting/HighlightableString';

import { shouldCopyInsteadOfMergeForKey } from './shouldCopyInsteadOfMerge';

export function modelDataDiffMerge<T>(modelData: T, diff: DeepPartial<T>): T {
  return _.mergeWith(modelData, diff, (objValue, srcValue, key, object, source) => {
    if (isHighlightableString(objValue)) {
      const hsSource = srcValue as HighlightableString;
      const hsTarget = objValue as HighlightableString;
      hsTarget.highlighted = hsSource.highlighted;
      return hsTarget;
    }
    if (shouldCopyInsteadOfMergeForKey({ key, source: srcValue })) {
      return srcValue;
    }
    if (objValue instanceof Map) {
      const targetMap = objValue as Map<any, any>;
      const sourceMap = srcValue as Map<any, any>;

      Array.from(sourceMap.entries()).forEach((entry) => {
        const entryKey = entry[0];
        const targetValue = targetMap.get(entryKey);
        if (typeof targetValue === 'undefined') {
          console.error(`Value in target map for key ${entryKey} is undefined`, source, object);
          throw new Error(`Value in target map for key ${entryKey} is undefined`);
        }

        const entryDiff = entry[1];

        if (typeof targetValue === 'object') {
          if (typeof entryDiff === 'object') {
            const newValue = modelDataDiffMerge(targetValue, entryDiff);
            targetMap.set(entryKey, newValue);
          } else {
            throw new Error(`Different types for key ${entryKey}: ${entryDiff} ${targetValue}`);
          }
        } else {
          targetMap.set(entryKey, entryDiff);
        }
      });

      return targetMap;
    }
    return undefined;
  });
}
